import React, { ReactElement } from 'react';
import { MailIcon } from '../icons/icons';

const Mail: React.FC<{ className?: string }> = ({
  className,
}): ReactElement => (
  <a
    href="mailto:office@novalogo.ro"
    className={`cursor-pointer flex items-center ${className}`}
  >
    <MailIcon />
    <span className="ml-1">office@novalogo.ro</span>
  </a>
);

export default Mail;
